export default __webpack_public_path__ + "static/media/python.e832f84c.svg";